import React from 'react';
import { Grid } from '@mui/material';
import CustomCard2 from '../../components/cards/CustomCard2';
import BranchWidget from '../../components/widgets/BranchWidget';
import PageLayout from '../layouts/PageLayout';
import BranchesSidebar from '../../components/sidebars/BranchesSidebar';
import { useSelector } from 'react-redux';
import { isEmpty, map, reverse, size } from 'lodash';
import { Toaster } from 'react-hot-toast';
import { branchesSelector } from '../../features/selectors';
import CountBadge from '../../components/CountBadge';
import NoDataFeedback from '../../components/feedbacks/NoDataFeedback';

const Branches = () => {
    const { branches } = useSelector(branchesSelector);

    return (
        <>
            <PageLayout
                head="Branches managements"
                sidebar={<BranchesSidebar branches={branches} />}
            >
                <CustomCard2
                    title={`CAICA Branches`}
                    heightClear={640}
                    action={
                        <CountBadge total={size(branches)} item={'Branches'} />
                    }
                >
                    {isEmpty(branches) ? (
                        <NoDataFeedback message={'No branch added'} />
                    ) : (
                        <Grid container spacing={3} padding={2}>
                            {reverse(
                                map(branches, (branch) => (
                                    <Grid item sm={6} key={branch.id}>
                                        <BranchWidget branch={branch} />
                                    </Grid>
                                )),
                            )}
                        </Grid>
                    )}
                </CustomCard2>
                <Toaster />
            </PageLayout>
        </>
    );
};

export default Branches;
